module.exports = "/assets/landing-rc/promo/kinley-photo-small@2x.jpg?BuNElfC";